
import ProgramsHero from './components/ProgramsHero';
import AgeGroupsSection from './components/AgeGroupsSection';
import CampsSection from './components/CampsSection';
import TournamentsSection from './components/TournamentsSection';

export default function Programs() {
  return (
    <div className="min-h-screen">
      <ProgramsHero />
      <AgeGroupsSection />
      <CampsSection />
      <TournamentsSection />
    </div>
  );
}
